import { render, staticRenderFns } from "./CompanySettingsView.vue?vue&type=template&id=3db8e9c6"
import script from "./CompanySettingsView.vue?vue&type=script&lang=ts"
export * from "./CompanySettingsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports